/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { Box, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { CiSearch } from 'react-icons/ci';
import { SlArrowDown, SlArrowUp } from 'react-icons/sl';
import CloseIcon from '@mui/icons-material/Close';
import dayjs, { Dayjs } from 'dayjs';
import { LanguageContext } from '../../../../libs/Context';

const SearchActivites = (props) =>
{
	const { searchValue, disabled, filterDate,
		totalSrchMtchdCnt, handleUpdateInd,
		matchedInd, handleUpdateState } = props;
	const [ showSearchBox, setShowSearchBox ] = useState<any>(false);
	const language = useContext(LanguageContext);
	const [ dateopen, setDateOpen ] = useState<any>({
		anchorEl : null,
		open     : false
	});

	const handleDateChange = (newValue: Dayjs | null) =>
	{
		setDateOpen((prev) => ({ ...prev, open: false, anchorEl: null }));
		handleUpdateState({ filterDate: newValue ? newValue?.valueOf() : dayjs() });
	};

	const handleOpenCalendar = (event: React.MouseEvent<HTMLButtonElement>) =>
	{
		setDateOpen((prev) => ({ ...prev,
			anchorEl : event.currentTarget,
			open     : true }));
	};

	const handleKeyPress = (e) =>
	{
		if (e.key === 'Enter' && searchValue !== '')
		{
			handleUpdateInd('increase');
		}
	};

	const handleClose = () =>
	{
		setShowSearchBox(false);
		handleUpdateState({ search: '' });
	};

	return (
		<>
			{!showSearchBox
				? (
					<IconButton size='small' onClick={() => setShowSearchBox(true)}>
						<IoIosSearch fontSize='var(--pixel20)' />
					</IconButton>
				)
				: (
					<Box display='flex' alignItems='center' gap={1} justifyContent={'end'}>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DesktopDatePicker
								open={dateopen?.open}
								onClose={() => setDateOpen((prev) =>
									({ ...prev, open: false, anchorEl: null }))}
								value={filterDate || new Date()?.valueOf()}
								onChange={handleDateChange}
								maxDate={dayjs()}
								PopperProps={{
									anchorEl      : dateopen?.anchorEl,
									disablePortal : true,
									placement     : 'bottom-start',
									modifiers     : [
										{
											name    : 'offset',
											options : {
												offset : [ 0, 10 ]
											}
										}
									],
									sx : {
										zIndex             : 1300,
										scale              : '0.8',
										transformOrigin    : 'top',
										'& .MuiPaper-root' : {
											borderRadius    : 2,
											boxShadow       : 3,
											padding         : 0,
											backgroundColor : 'var(--whiteColor)'
										}
									}
								}}
								renderInput={(params) => (
									<input
										{...params.inputProps}
										style={{ display: 'none' }}
									/>
								)}
							/>
							{/* Trigger Calendar Popup */}
							<Box sx={{ position: 'relative', display: 'inline-flex' }}>
								<IconButton size='small' onClick={handleOpenCalendar}>
									<MdOutlineCalendarMonth fontSize='var(--pixel20)' color='#23A4C4' />
								</IconButton>
								{filterDate && (
									<IconButton
										size='small'
										onClick={() => handleUpdateState({ filterDate: '' })}
										sx={{
											position        : 'absolute',
											top             : -4,
											right           : -4,
											padding         : '2px',
											backgroundColor : 'var(--whiteColor)',
											border          : '1px solid #ccc',
											'&:hover'       : {
												backgroundColor : '#f5f5f5'
											}
										}}
									>
										<CloseIcon sx={{ fontSize: '10px' }} />
									</IconButton>
								)}
							</Box>
						</LocalizationProvider>
						{/* </Popover> */}
						<TextField
							variant='standard'
							placeholder={language?.searchByCompanyName}
							size='small'
							value={searchValue}
							onKeyPress={handleKeyPress}
							onChange={(e) => handleUpdateState({ search: e?.target?.value?.replace(/^\s+/, '') })}
							disabled={disabled}
							InputProps={{
								startAdornment : (
									<InputAdornment position='start'>
										<CiSearch fontSize='var(--pixel16)' />
									</InputAdornment>
								),
								endAdornment : (
									<InputAdornment position='end'>
										<Stack direction='row' alignItems='center' spacing={0.5}>
											{searchValue !== '' &&
											<Typography fontSize='var(--pixel12)'>{`${matchedInd || 0}/${totalSrchMtchdCnt || 0}`}</Typography>
											}
											<IconButton size='small' disabled={searchValue === ''}>
												<SlArrowUp fontSize={14}
													onClick={() => handleUpdateInd('decrease')}
												/>
											</IconButton>
											<IconButton size='small' disabled={searchValue === ''}>
												<SlArrowDown fontSize={14}
													onClick={() => handleUpdateInd('increase')}
												/>
											</IconButton>
											<IconButton size='small'
												onClick={handleClose}
											>

												<CloseIcon sx={{ fontSize: 'var(--pixel14)' }} />
											</IconButton>
										</Stack>
									</InputAdornment>
								)
							}}
							sx={{ width                  : '65%',
								'& .MuiInputBase-root' : {
									borderBottom                         : '1px solid #ccc',
									'&:hover:not(.Mui-disabled)::before' : {
										borderBottom : '1px solid #3BB9CE'
									}
								},
								'& .MuiInputBase-root::before' : {
									borderBottom : '1px solid #ccc'
								},
								'& .MuiInputBase-root.Mui-focused::before' : {
									borderBottom : '1px solid #23A4C4'
								},
								'& .MuiInputBase-root.Mui-focused::after' : {
									borderBottom : 'none'
								}
							}}
						/>
					</Box>

				)}
		</>
	);
};

export default SearchActivites;